export default __webpack_public_path__ + "static/media/guest_vitor_cruz.224b6018.png";